import React, {Component} from 'react';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import FormValidator from "../FormValidator";

const initialState = {
  accountnumber: '',
  meternumber: '',
  meterreading: '',
  deliveryDate: '',
  refnumber: ''
}

class LocationFact extends Component{
  constructor(props){
    super(props);

    this.validator = new FormValidator([
      // using validator package methods https://www.npmjs.com/package/validator
      {
        field: 'accountnumber',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die Vertragskontonummer an.'
      },
      {
        field: 'accountnumber',
        method: 'isInt',
        validWhen: true,
        message: 'Die Vetragskontonummer besteht aus Ziffern.'
      },
      {
        field: 'accountnumber',
        method: 'isLength',
        args: [{min: 12, max: 12}],
        validWhen: true,
        message: 'Ihre Vertragskontonummer besteht aus 12 Ziffern.'
      },
      {
        field: 'accountnumber',
        method: this.checkAccountNumber,
        validWhen: true,
        message: 'Ihre Vertragskontonummer beginnt mit der Ziffer "2".'
      },
      {
        field: 'meternumber',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die Zählernummer an.'
      },
      {
        field: 'meterreading',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie den Zählerstand an.'
      },
      {
        field: 'deliveryDate',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie das Lieferende an.'
      },
      {
        field: 'deliveryDate',
        method: this.checkDeliveryDate,
        args: [{ignore_whitespace:true}],
        validWhen: true,
        message: 'Das Lieferende darf maximal 6 Wochen in der Vergangenheit liegen.'
      },
    ]);

    this.state = {
      ...initialState,
      ...props.state,
      validation: this.validator.valid()
    }

    const isVal = this.validator.validate(this.state);
    props.isValidForm(isVal.isValid, 'locationValidation');

    this.handleChange = this.handleChange.bind(this);
  }

  checkAccountNumber= () => {
    if (this.props.state.accountnumber[0] === '2') {
      return true;
    }
  }
  checkDeliveryDate = () => {
    var today= new Date();
    var min= new Date(today);
    min.setDate(min.getDate() - 43);
    var selected= new Date(this.state.deliveryDate);
    if (selected.getTime() > min.getTime() ) {
      return true;
    }
    else {
     return false;
    }
  }

  componentDidUpdate() {
    // check if the upper instance has resettet its state
    if(this.state.accountnumber !== this.props.state.accountnumber){
      // reset too
      this.setState({
        ...this.props.state,
        deliveryDate: ''
      });
    }
  }

  handleChange(event) {
    this.props.changeHandler(event);

    let valueName = event.target.name;
    if(event.target.name === "deliveryEndDate" || event.target.name === "deliveryStartDate") {
        valueName = "deliveryDate";
    }
    this.setState({
      [valueName]: event.target.value
    }, () => { // callback to send validation to upper instance after state was updatet
      const isVal = this.validator.validate(this.state);
      this.props.isValidForm(isVal.isValid, 'locationValidation');
    });
  }

  render(){
    // validator will start alerting after first submission
    let validation = this.props.submitted ? this.validator.validate(this.state) : this.state.validation;

    let deliveryDate;
    if(this.props.isRegistration){
      deliveryDate = 
        <div>
        <Label for="deliveryStartDate">Lieferbeginn*</Label>
        <Input type="date" name="deliveryStartDate" value={this.state.deliveryDate} id="deliveryStartDate" onBlur={this.handleChange.bind(this)} onChange={this.handleChange.bind(this)} />
        </div>;
    } else {
      deliveryDate = 
        <div>
        <Label for="deliveryEndDate">Lieferende*</Label>
        <Input type="date" name="deliveryEndDate" value={this.state.deliveryDate} id="deliveryEndDate" onBlur={this.handleChange.bind(this)} onChange={this.handleChange.bind(this)} />
        </div>;
    }
    let accountNumber;
    if(!this.props.isRegistration){
      accountNumber = 
      <div>
           <Label for="accountnumber">Vertragskontonummer*</Label>
              <Input type="number" placeholder="EINGABEFORMAT: 200123456789" value={this.state.accountnumber} name="accountnumber" id="accountnumber" onBlur={this.handleChange.bind(this)} onChange={this.handleChange.bind(this)} />
      </div>
    }

    return (
      <div>
      <Row>
        <Col md={6}>
          <FormGroup>
            <div className={validation.accountnumber.isInvalid ? 'has-error' : ''}>
             {accountNumber}
              <span className="help-block">{validation.accountnumber.message}</span>
            </div>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <div className={validation.meternumber.isInvalid ? 'has-error' : ''}>
              <Label for="meternumber">Zählernummer*</Label>
              <Input type="text" value={this.state.meternumber} name="meternumber" id="meternumber" onBlur={this.handleChange.bind(this)} onChange={this.handleChange.bind(this)} />
              <span className="help-block">{validation.meternumber.message}</span>
            </div>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <div className={validation.meterreading.isInvalid ? 'has-error' : ''}>
              <Label for="meterreading">Zählerstand*</Label>
              <Input type="number" name="meterreading" value={this.state.meterreading} id="meterreading" onBlur={this.handleChange.bind(this)} onChange={this.handleChange.bind(this)} />
              <span className="help-block">{validation.meterreading.message}</span>
            </div>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <div className={validation.deliveryDate.isInvalid ? 'has-error' : ''}>
              {deliveryDate}
              <span className="help-block">{validation.deliveryDate.message}</span>
            </div>
          </FormGroup>
        </Col>
      </Row>
      </div>
    );
  }
}

export default LocationFact;


// WEBPACK FOOTER //
// ./src/components/FormGroups/LocationFacts.js